import { REQUEST, RECEIVE } from '../../types/referenten'
import config from '../../config'

import { stringify } from 'querystring'

function doFetch(dispatch, currentState, themaId, bezirk = null, kreis = null, fulltextThema = null, fulltextReferent = null, einsatzgebiet = null) {
    dispatch({
        type: REQUEST,
        data: themaId
    })
    return fetch(config.baseUrl+'/api/biwe/v1/referenten?'+stringify({themaId, bezirk, kreis, fulltextThema, fulltextReferent, einsatzgebiet}))
        .then(result => result.json())
        .then(
            data => {
                dispatch({
                    type: RECEIVE,
                    data
                })
            }
        )
}

export function fetchReferenten(thema = null) {

    return (dispatch, getState) => {
        let currentState = getState()
        let currentBezirk = currentState.bezirke.selected
        let currentKreis = currentState.kreise.selected
        let filters = currentState.filters
        let fulltextThema = filters.themen
        let fulltextReferent = filters.referenten
        let einsatzgebiet = filters.einsatzgebiet

        return doFetch(dispatch, currentState, thema, currentBezirk, currentKreis, fulltextThema, fulltextReferent, einsatzgebiet)
    }
}


// WEBPACK FOOTER //
// ./src/actions/referenten/referenten.js